import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import dayjs from "dayjs";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

interface MFADeviceListProps {
  factors: any[];
  onUnenroll: (factorId: string) => void;
}

export const MFADeviceList = ({ factors, onUnenroll }: MFADeviceListProps) => {
  return (
    <div className="space-y-3">
      {factors.map((factor) => (
        <Card key={factor.id}>
          <CardContent className="pt-4">
            <div className="flex items-center justify-between">
              <div className="space-y-1">
                <div className="flex items-center gap-2">
                  <h4 className="font-medium">{factor.friendly_name || "Authenticator App"}</h4>
                  <Badge variant="secondary">TOTP</Badge>
                </div>
                <p className="text-sm text-muted-foreground">
                  Added {dayjs(factor.created_at).tz().format("DD/MM/YYYY")}
                </p>
              </div>

              <AlertDialog>
                <AlertDialogTrigger asChild>
                  <Button variant="outline" size="sm">
                    Remove
                  </Button>
                </AlertDialogTrigger>
                <AlertDialogContent>
                  <AlertDialogHeader>
                    <AlertDialogTitle>Remove MFA Device</AlertDialogTitle>
                    <AlertDialogDescription>
                      Are you sure you want to remove this MFA device? This will reduce the security of your account.
                    </AlertDialogDescription>
                  </AlertDialogHeader>
                  <AlertDialogFooter>
                    <AlertDialogCancel>Cancel</AlertDialogCancel>
                    <AlertDialogAction onClick={() => onUnenroll(factor.id)}>Remove Device</AlertDialogAction>
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialog>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
